import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bagtag.webp';
import screenshot_target from '../../../images/letterfunnel/jasperquak.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jasper Quak"
      firstname="Jasper"
      companyname="BAGTAG"
      competition="BagID en ViewTag"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jasperquak.js